var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-tabs",
        {
          staticStyle: { "padding-left": "65px" },
          attrs: { centered: "", "icons-and-text": "" }
        },
        [
          _c("v-tabs-slider", { staticStyle: { display: "none" } }),
          _c("v-divider", {
            staticClass: "mx-12",
            staticStyle: {},
            attrs: { inset: "", vertical: "" }
          }),
          _c("v-select", {
            staticStyle: { "max-width": "90px", "padding-top": "15px" },
            attrs: {
              items: _vm.items,
              "item-text": "nombre",
              "item-value": "id",
              label: "Filtrar Resultados...",
              "hide-details": "",
              solo: "",
              flat: ""
            },
            on: {
              change: function($event) {
                _vm.elementosSeleccionados = []
                _vm.elementosSelect = []
                _vm.searchVehiculo = ""
                _vm.changeFiltro()
              }
            },
            model: {
              value: _vm.model,
              callback: function($$v) {
                _vm.model = $$v
              },
              expression: "model"
            }
          }),
          _c("v-text-field", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showSelect,
                expression: "!showSelect"
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: {
                  rules: {
                    max: 6,
                    min: 5,
                    regex: "[A-Z0-9]+"
                  }
                },
                expression:
                  "{\n        rules: {\n          max: 6,\n          min: 5,\n          regex: '[A-Z0-9]+',\n        },\n      }"
              }
            ],
            style: _vm.estilosIndicadores,
            attrs: {
              label: "Patente",
              counter: 6,
              change: _vm.patenteInput(),
              placeholder: "EJ: AAZZ00",
              "error-messages": _vm.errors.collect("patente"),
              "data-vv-name": "patente",
              type: "text",
              required: "",
              "append-icon": "search",
              "single-line": "",
              "hide-details": ""
            },
            on: {
              keypress: function($event) {
                $event.keyCode < 48 ||
                ($event.keyCode > 57 && $event.keyCode < 65) ||
                ($event.keyCode > 90 && $event.keyCode < 97) ||
                $event.keyCode > 122
                  ? $event.preventDefault()
                  : false
              },
              "click:append": _vm.changeFiltro,
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.changeFiltro($event)
              }
            },
            model: {
              value: _vm.searchVehiculo,
              callback: function($$v) {
                _vm.searchVehiculo = $$v
              },
              expression: "searchVehiculo"
            }
          }),
          _c("v-select", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showSelect,
                expression: "showSelect"
              }
            ],
            style: _vm.estilosIndicadores,
            attrs: {
              items: _vm.elementosSelect,
              "item-text": "nombre",
              "item-value": "id",
              multiple: "",
              flat: "",
              "no-data-text": "Sin resultados"
            },
            on: {
              input: _vm.emitirTextoBusqueda,
              change: function($event) {
                return _vm.validateSelectedAll()
              }
            },
            scopedSlots: _vm._u([
              {
                key: "prepend-item",
                fn: function() {
                  return [
                    _c(
                      "v-list-tile",
                      [
                        _c("v-checkbox", {
                          attrs: { label: "Seleccionar todos" },
                          on: {
                            change: function($event) {
                              return _vm.selectAll()
                            }
                          },
                          model: {
                            value: _vm.checkAll,
                            callback: function($$v) {
                              _vm.checkAll = $$v
                            },
                            expression: "checkAll"
                          }
                        })
                      ],
                      1
                    ),
                    _c("v-divider")
                  ]
                },
                proxy: true
              },
              {
                key: "selection",
                fn: function(ref) {
                  var item = ref.item
                  var index = ref.index
                  return [
                    index === 0
                      ? _c("v-chip", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.textoComprimido(item.nombre)))
                          ])
                        ])
                      : _vm._e(),
                    index === 1
                      ? _c("span", { staticClass: "grey--text caption" }, [
                          _vm._v(
                            "(+" +
                              _vm._s(_vm.elementosSeleccionados.length - 1) +
                              " otros)"
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ]),
            model: {
              value: _vm.elementosSeleccionados,
              callback: function($$v) {
                _vm.elementosSeleccionados = $$v
              },
              expression: "elementosSeleccionados"
            }
          }),
          _c(
            "div",
            { staticStyle: { "padding-top": "10px" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "#27488E",
                    disabled: _vm.btnBloquear,
                    fab: "",
                    small: "",
                    dark: ""
                  },
                  on: { click: _vm.changeFiltro }
                },
                [_c("v-icon", [_vm._v("search")])],
                1
              )
            ],
            1
          ),
          _c("v-divider", {
            staticClass: "mx-12",
            staticStyle: { "padding-left": "10px" },
            attrs: { inset: "", vertical: "" }
          }),
          _c(
            "v-container",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.indicadores.visible,
                  expression: "indicadores.visible"
                }
              ],
              staticStyle: { "padding-top": "10px !important" }
            },
            [
              _c(
                "v-layout",
                [
                  _c("v-flex", { attrs: { xs2: "", md2: "", lg2: "" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "20px",
                          "padding-left": "50px"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.vehiculosEnTotal) +
                            "\n          "
                        )
                      ]
                    ),
                    _c("br"),
                    _c(
                      "span",
                      {
                        staticClass: "labelTabs",
                        staticStyle: { "padding-left": "1px" }
                      },
                      [_vm._v("VEHÍCULOS EN TOTAL")]
                    )
                  ]),
                  _c("v-flex", { attrs: { xs3: "", md3: "", lg3: "" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "20px",
                          "padding-left": "75px"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.vehiculosTransmitiendo) +
                            "\n          "
                        )
                      ]
                    ),
                    _c("br"),
                    _c(
                      "span",
                      {
                        staticClass: "labelTabs",
                        staticStyle: { "padding-left": "29px" }
                      },
                      [_vm._v("VEHÍCULOS EN LÍNEA")]
                    )
                  ]),
                  _c("v-flex", { attrs: { xs3: "", md3: "", lg3: "" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "20px",
                          "padding-left": "60px"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.vehiculosSinTransmitir) +
                            "\n          "
                        )
                      ]
                    ),
                    _c("br"),
                    _c(
                      "span",
                      {
                        staticClass: "labelTabs",
                        staticStyle: { width: "10px" }
                      },
                      [_vm._v("VEHÍCULOS FUERA DE LÍNEA")]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.modalSearchVehiculo,
          titulo: _vm.tituloSearchVehiculo,
          mensaje: _vm.mensajeSearchVehiculo,
          textoBtnSi: _vm.$t("mensajes.crud.cambioCliente.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.cambioCliente.btnCancelar"),
          width: 390
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.searchVehiculoCallback($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }